const AnalyticsHubIcon = (): JSX.Element => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_9843_2579" mask-type= "alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect width="32" height="32" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_9843_2579)">
        <path d="M4.3335 27.6666V25.4743L6.3335 23.4743V27.6666H4.3335ZM9.66683 27.6666V20.141L11.6668 18.141V27.6666H9.66683ZM15.0002 27.6666V18.141L17.0002 20.1743V27.6666H15.0002ZM20.3335 27.6666V20.1743L22.3335 18.1743V27.6666H20.3335ZM25.6668 27.6666V14.8076L27.6668 12.8076V27.6666H25.6668ZM4.3335 20.2923V17.4743L13.3335 8.47428L18.6668 13.8076L27.6668 4.80762V7.62562L18.6668 16.6256L13.3335 11.2923L4.3335 20.2923Z" fill="#999B9F"/>
        </g>
        </svg>

    )
}
export default AnalyticsHubIcon